export default "__VITE_ASSET__BDe$snQd__"